export default __webpack_public_path__ + "static/media/evac_logo.96f35b24.png";